import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

//import './services';

import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { FlashMessageProvider } from "contexts/FlashMessageContext";
import App from './layout/App';
import reducer from './store/reducer';
import './assets/scss/style.scss';
import * as serviceWorker from './serviceWorker';
import config from './config';

library.add(far, fas);

export const store = createStore(reducer);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <Provider store={store}>
	    <FlashMessageProvider>
		<BrowserRouter basename={config.basename}>
                    <App />
		</BrowserRouter>
	    </FlashMessageProvider>
        </Provider>
    </React.StrictMode>
    
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
